var styles = {"box":"OptionsGrid_box_1pqpb_1","border-top":"OptionsGrid_border-top_1pqpb_4","option-wrapper":"OptionsGrid_option-wrapper_1pqpb_9","checkbox":"OptionsGrid_checkbox_1pqpb_12","selected":"OptionsGrid_selected_1pqpb_49","group-name":"OptionsGrid_group-name_1pqpb_55"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
